import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { useCart } from '../contexts/CartContext';
import ProductGrid from '../components/ProductGrid';
import './Products.css';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../features/store';
import { useSelector } from 'react-redux';
import { getProductsByCategory, selectAllCategories, selectCategoryProducts } from '../features/categories';
import Loader from '../components/Loader';
import { CategoryProduct } from '../features/categories/categoryModels';
import { Product } from '../features/products/productModels';
import { getAllProducts } from '../features/products/productThunks';
import { selectAllProducts } from '../features/products';

const Products: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { addToCart } = useCart();
  const [wishlistItems, setWishlistItems] = useState<string[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<CategoryProduct[]|Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const category = searchParams.get('category') || '';
  const dispatch:AppDispatch=useDispatch();
  const categories=useSelector(selectAllCategories);
  const categoryProducts=useSelector(selectCategoryProducts);
  const allProducts=useSelector(selectAllProducts);
  const [response, setResponse] = useState<any>(null);

  
  // Filter products based on categ ory
  useEffect(() => {
    // Scroll to top when category changes
    window.scrollTo(0, 0);
    
    setFilteredProducts([]);
    if(category){
      setIsLoading(true);
      const response = dispatch(getProductsByCategory({ categoryId: category }));
      setResponse(response);
    }
    else{
      setIsLoading(true);
      const response = dispatch(getAllProducts());
      setResponse(response);
    }
    }, [category]);

    useEffect(() => {
      if (categoryProducts.length > 0) {
        setFilteredProducts([...categoryProducts] as CategoryProduct[]);
        setIsLoading(false);
      }
      if(allProducts.length > 0 && !category){
        setFilteredProducts([...allProducts] as Product[]);
        setIsLoading(false);
      }
      if(response){
        setIsLoading(false);
      }
    }, [categoryProducts,allProducts]);

  const handleAddToCart = (product: CategoryProduct|Product) => {
    // addToCart(product, 1);
  };

  const handleToggleWishlist = (productId: number) => {
    setWishlistItems(prev => 
      prev.includes(productId.toString()) 
        ? prev.filter(id => id !== productId.toString())
        : [...prev, productId.toString()]
    );
  };

  const getPageTitle = () => {
    if (category) {
      const categoryName = categories.find(cat => cat._id === category)?.categoryName || category;
      return t('products.categoryProducts', { categoryName });
    }
    return t('products.allProducts');
  };

  if (isLoading) {
    return (
      <div className="products-page1">
         <Loader size="large" text={t('products.loadingProducts')} />
      </div>
    );
  }
 
  if (filteredProducts.length === 0 &&  !isLoading ) {
    return (
      <div className="products-page">
        <div className="no-products-container">
          <div className="no-products-content">
            <ShoppingBagIcon className="no-products-icon" />
            <h1>{t('products.noProductsFound')}</h1>
            <p>{t('products.noProductsDescription')}</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="products-page">
      <div className="container">
        {/* Page Header */}
        <div className="page-header">
          <h1>{getPageTitle()}</h1>
          <p>{t('products.showingProducts', { count: filteredProducts.length })}</p>
        </div>
      
        {/* Products Grid */}
        <ProductGrid
          products={filteredProducts}
          onAddToCart={handleAddToCart}
          onToggleWishlist={handleToggleWishlist}
          wishlistItems={wishlistItems}
          showFilters={false}
        />
      </div>
    </div>
  );
};

export default Products;
